import app from 'flarum/forum/app';
import m from 'mithril';
import Component from 'flarum/common/Component';
import { emotes, emoteView } from '../../common/emotes';
/** Przycisk 🙂 + okienko z emotkami ustawionymi przez administratora. */
export default class EmotePicker extends Component {
  open = false;
  _onDoc = e => {
    if (this.open && this.element && !this.element.contains(e.target)) {
      this.open = false;
      m.redraw();
    }
  };
  _onKey = e => {
    if (this.open && e.key === 'Escape') {
      this.open = false;
      m.redraw();
    }
  };
  oncreate(vnode) {
    super.oncreate(vnode);
    document.addEventListener('mousedown', this._onDoc);
    document.addEventListener('keydown', this._onKey);
  }
  onremove(vnode) {
    super.onremove(vnode);
    document.removeEventListener('mousedown', this._onDoc);
    document.removeEventListener('keydown', this._onKey);
  }
  view() {
    const list = emotes();
    if (!list.length) return null;
    return m('div', {
      className: 'ShoutEmotePicker' + (this.open ? ' is-open' : '')
    }, [m('button', {
      type: 'button',
      className: 'ShoutEmotePicker-toggle',
      title: app.translator.trans('swtorpolska-shoutbox.forum.emotes.toggle'),
      'aria-expanded': String(this.open),
      disabled: this.attrs.disabled,
      onclick: () => this.open = !this.open
    }, m('i', {
      className: 'far fa-face-smile'
    })), this.open ? m('div', {
      className: 'ShoutEmotePicker-panel',
      role: 'listbox'
    }, [m('div', {
      className: 'ShoutEmotePicker-title'
    }, app.translator.trans('swtorpolska-shoutbox.forum.emotes.title')), m('div', {
      className: 'ShoutEmotePicker-grid'
    }, list.map(e => m('button', {
      type: 'button',
      key: e.id,
      className: 'ShoutEmotePicker-item',
      title: (e.label || e.code || '') + (e.code ? '  :' + e.code + ':' : ''),
      // mousedown, żeby pole tekstowe nie traciło kursora
      onmousedown: ev => ev.preventDefault(),
      onclick: ev => {
        this.attrs.onpick(e);
        // Shift+klik = wstaw kilka emotek bez zamykania
        if (!ev.shiftKey) this.open = false;
      }
    }, emoteView(e, 'ShoutEmotePicker-emote')))), m('div', {
      className: 'ShoutEmotePicker-hint'
    }, app.translator.trans('swtorpolska-shoutbox.forum.emotes.hint'))]) : null]);
  }
}
flarum.reg.add('swtorpolska-shoutbox', 'forum/components/EmotePicker', EmotePicker);